export default {
  csvExport(fileName, arrData) {
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += [
      Object.keys(arrData[0]).join(";"),
      ...arrData.map(item => Object.values(item).join(";")),
    ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", fileName.replace(/\s/g, '') + ".csv");
    link.click();
  },
  convertUserResult(item) {
    let userResult = {};
    userResult["user"] = `${item.user.lastName}  ${item.user.name}`;
    item.results.forEach((result) => {
      userResult[result.examName] = result.score;
    });
    return userResult
  },

  getExamByGroup(groupName, items) {
    let arrData = []
    items.forEach(it => {
      arrData.push(this.convertUserResult(it))
    })
    this.csvExport(groupName, arrData)
  }
};

